exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.flex-break[data-v-066f1b8c] {\n    -ms-flex-preferred-size: 100%;\n        flex-basis: 100%;\n    height: 0;\n}\n.flex-wrap[data-v-066f1b8c] {\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n", ""]);

// exports
